import { USER_LIST, USER_LIST_LOADER } from "../actions/type";

const initialState = {
  userList: {},
  userListLoader: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case USER_LIST:
      return {
        ...state,
        userList: payload,
        userListLoader: false,
      }; 

    case USER_LIST_LOADER:
      return {
        ...state,
        userListLoader: payload,
      };
    default:
      return state;
  }
}
